import type {AxiosRequestConfig} from 'axios';
import {mapKeys, snakeCase} from 'lodash-es';

import {spotheroPost} from 'api';
import type {EventVenue} from './events.types';
import {sendSentryException} from 'utils/error-handling';
import {camelizeKeys} from 'utils/format-strings';

/**
 * Format the response of the Event Venue options.
 */
const formatEventVenuesRequest = (facilityIds: number[]) => {
    const formattedData = mapKeys({facilityIds}, (value, key) =>
        snakeCase(key)
    );

    return formattedData;
};

/**
 * Converts the given data object into the format expected by the frontend by renaming keys to camelCase.
 */
const formatEventVenuesResponse = (data: EventVenue[]) => {
    const formattedData = camelizeKeys(data);

    return formattedData;
};

/**
 * Gets a collection of venues for a given facility ID
 * @see '/api/v1/events/tiered-event-rating-types/destinations/'
 */
const getEventVenues = async (
    facilityIds: number[],
    config: AxiosRequestConfig = {}
) => {
    try {
        const formatedRequest = formatEventVenuesRequest(facilityIds);

        const response = await spotheroPost<EventVenue[]>(
            `events/tiered-event-rating-types/destinations/`,
            formatedRequest,
            config,
            false
        );

        const formattedResponse = formatEventVenuesResponse(
            response.data.data.results
        );

        return formattedResponse;
    } catch (error) {
        sendSentryException(error);
        throw error;
    }
};

export default getEventVenues;
